import { useParams } from "react-router-dom"
import InnerHeader from "../../Layouts/InnerHeader"
import Loading from "../../Layouts/Loading"
import { useState } from "react"
import Error404 from "../../Layouts/Error404"
import { InvoicePay, useGetInvoiceQuery, usePayOnlineInvoiceMutation } from "../../Redux/Apis/invoiceApi"
import { fa_currency, fa_date, fa_number } from "../../utils/Persian"
import Invoice from "./Invoice"

const TransactionSubType:any = {
    ADMIN: "مدیریت",
    ONLINE: 'آنلاین',
    CARD: 'کارت به کارت',
    SHOP: 'فروشگاه',
    CRM:   'سامانه',
}
  
const TransactionStatus:any = {
    EXPIRED: 'منقضی شده',
    FAILED:  'ناموفق',
    WAIT:    'در انتظار',
    SUCCESS: 'موفق',
}

export default function InvoiceView() {
    let {invoiceId} = useParams();
    const [payOnline, {isLoading: isPayLoading}] = usePayOnlineInvoiceMutation()

    const [link,setLink] = useState<InvoicePay>()

    const [errorMsg, setErrorMsg] = useState<any>(false)
    const {
        data,
        isLoading,
        isSuccess,
        isError,
    } = useGetInvoiceQuery(invoiceId)
    
    const handlePay = async (id:number) => {
        try {
            const link = await payOnline(id).unwrap()
            if (link.url) {
                setLink(link)
                setErrorMsg(false)
                setTimeout(() => { 
                    window.location = link.url;
                }, 3000)
            }
            else {
                setErrorMsg("پرداخت با مشکل مواجع شد.")
            }
            
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Invoice/>

    else if(isSuccess && data) {
        return(
            <div className="container-lg">
                <InnerHeader name={`صورتحساب شماره ${fa_number(data.invoice.id)}`} root='/invoice'/>
                {errorMsg && <div className="alert alert-danger" role="alert">
                    {errorMsg}
                </div>}
                <div className="row justify-content-center">
                    <div className="col-md-8 border rounded shadow p-4 mb-3" id="invoice_view">
                        <div className="corner-ribbon__inner">
                            {data.invoice.status === "PAY" && <div className="corner-ribbon__ribbon text-bg-success"></div>}
                            {data.invoice.status === "NOT_PAY" && <div className="corner-ribbon__ribbon text-bg-danger"></div>}
                        </div>
                        <h6>اطلاعات صورتحساب:</h6>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td className="text-end">شماره صورتحساب:</td>
                                    <td className="w-75">{fa_number(data.invoice.id)}</td>
                                </tr>
                                <tr>
                                    <td className="text-end">مبلغ:</td>
                                    <td className="w-75">{fa_currency(+data.invoice.price)} تومان</td>
                                </tr>
                                <tr>
                                    <td className="text-end">مبلغ تخفیف:</td>
                                    <td className="w-75">{data.invoice.discount ? fa_currency(+data.invoice.discount) : '۰'} تومان</td>
                                </tr>
                                <tr>
                                    <td className="text-end">تاریخ ایجاد:</td>
                                    <td className="w-75">{fa_date(data.invoice.create_date)}</td>
                                </tr>
                                <tr>
                                    <td className="text-end">توضیحات:</td>
                                    <td className="w-75">{data.invoice.note}</td>
                                </tr>
                                <tr>
                                    <td className="text-end">وضعیت صورتحساب:</td>
                                    <td className="w-75">
                                        {data.invoice.status === "PAY" && <p className="text-success">پرداخت شده</p>}
                                        {data.invoice.status === "NOT_PAY" && <p className="text-danger">پرداخت نشده</p>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {data.invoice.status === "NOT_PAY" && <div className="col-md-8 border rounded p-4 shadow mb-3">
                        <h6 className="d-inline">پرداخت مبلغ صورتحساب: </h6>
                    
                        {link ? <button onClick={() => window.location = link.url} type="button" className="btn btn-primary">
                            <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
                            هدایت به درگاه...
                        </button>
                        :
                        <button disabled={isPayLoading} onClick={() => handlePay(data.invoice.id)} type="button" className="btn btn-success">
                            <i className="zmdi zmdi-card me-2"></i>
                            {`پرداخت آنلاین مبلغ ${fa_currency(+data.invoice.price)} تومان با درگاه مستقیم بانکی`}
                        </button>}
                    </div>}
                    <div className="col-md-8 border rounded shadow p-4">
                        <h6>تراکنش های صورتحساب:</h6>
                        {data.transactions && data.transactions.length > 0 ? 
                        <div className="table-responsive">
                            <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">مبلغ</th>
                                    <th scope="col">توضیحات</th>
                                    <th scope="col">شناسه پرداخت</th>
                                    <th scope="col">شناسه بانکی</th>
                                    <th scope="col">نوع</th>
                                    <th scope="col">وضعیت</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.transactions.map((value:any,index:number) => 
                                <tr key={index}>
                                    <th scope="row">{fa_number(index + 1)}</th>
                                    <td>{fa_currency(+value.price)}</td>
                                    <td>{value.description}</td>
                                    <td>{value.payment_auth}</td>
                                    <td>{value.online_ref_id}</td>
                                    <td>{TransactionSubType[value.sub_type]}</td>
                                    <td>{TransactionStatus[value.status]}</td>
                                </tr>
                                )}
                            </tbody>
                        </table></div> 
                        : <p>تراکنشی وجود ندارد</p>}
                    </div>
                </div>
            </div>
        )
    }

    else return <Error404/>
}